import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { useToast } from "@/hooks/use-toast";
import { useQueryClient } from "@tanstack/react-query";
import { tipsApi } from "@/services/api/tips";

export function TipSubmission() {
  const [tip, setTip] = useState("");
  const { toast } = useToast();
  const queryClient = useQueryClient();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!tip.trim()) return;

    setIsSubmitting(true);
    try {
      await tipsApi.submitTip({
        title: "Untitled Tip",
        description: tip.trim(),
        emoji: "❤️",
        addedBy: "Anonymous",
        status: "draft"
      });

      toast({
        title: "Tip submitted!",
        description: "Thanks for sharing! Your tip will be reviewed shortly.",
      });
      setTip("");
      queryClient.invalidateQueries({ queryKey: ['tips'] });
    } catch (error) {
      console.error('Error submitting tip:', error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to submit tip. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 bg-white/95 backdrop-blur-sm p-4 rounded-lg shadow-sm">
      <Textarea
        placeholder="Share your university survival tip..."
        value={tip}
        onChange={(e) => setTip(e.target.value)}
        required
        className="border-vaseline-blue/20 focus:border-vaseline-blue resize-none h-24"
      />
      <Button 
        type="submit" 
        className="w-full bg-vaseline-pink hover:bg-vaseline-pink/90 text-white font-semibold"
        disabled={isSubmitting}
      >
        {isSubmitting ? "Submitting..." : "Share Tip"}
      </Button>
    </form>
  );
}